import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

// Custom.
import Layout from "containers/Layout/Layout";
import { Form } from "@vocollege/components";
import I18n from "@vocollege/app/dist/modules/Services/I18n";
import {
  GET_CARD,
  UPDATE_CARD,
  CREATE_CARD,
} from "@vocollege/app/dist/modules/VoApi/graphql";
import { VoAuth } from "@vocollege/app";
import Utils from "services/Utils";

export default function CardEdit() {
  const router = useParams<any>();
  const navigate = useNavigate();

  // Methods.

  const getInitialState = () => {
    const initialState: { [key: string]: any } = {
      id: 0,
      title: "",
      body: "",
      status: 0,
      template: "standard",
      fields: [],
      settings: [],
      entity: null,
      author: null,
      images: [],
    };
    const { id } = router;
    if (id && id === "create") {
      initialState.author = {
        id: VoAuth.currentUser.id,
        name: VoAuth.currentUser.name,
        type: "user",
      };
    }
    return initialState;
  };

  const getAvailableTemplateValues = () => {
    return Object.keys(I18n.get.card.templates).map((template: string) => ({
      label: I18n.get.card.templates[template],
      value: template,
    }));
  };

  const handleRedirect = (state: any) => {
    if (Utils.redirect(state)) {
      toast.info(I18n.get.form.messages.redirecting, { autoClose: 0 });
    } else {
      navigate("/content/cards");
    }
  };

  return (
    <Layout>
      <Form
        tabs={[
          {
            key: "content",
            label: I18n.get.misc.content,
            fields: [
              {
                name: "title",
                label: I18n.get.form.labels.title,
                type: "text",
                required: true,
                grid: {
                  xs: 12,
                },
                validation: {
                  required: true,
                },
              },

              {
                name: "author",
                label: I18n.get.misc.author,
                type: "entity_field",
                grid: {
                  xs: 12,
                  md: 8,
                },
                params: {
                  dialog: {
                    types: ["user"],
                  },
                  fields: {
                    user: {
                      title: "name",
                    },
                  },
                },
              },
              {
                name: "status",
                label: I18n.get.status.published,
                type: "switch",
                required: true,
                grid: {
                  xs: 12,
                  md: 4,
                },
              },
              {
                name: "entity",
                label: I18n.get.entities.label.entity,
                type: "entity_field",
                grid: {
                  xs: 12,
                  md: 8,
                },
                params: {
                  dialog: {
                    types: ["user", "event", "page", "queue"],
                  },
                  fields: {
                    user: {
                      title: "name",
                    },
                    event: {
                      title: "title",
                    },
                    page: {
                      title: "title",
                    },
                    queue: {
                      title: "title",
                    },
                  },
                },
              },
              {
                name: "template",
                label: I18n.get.form.labels.template,
                type: "select",
                required: true,
                grid: {
                  xs: 12,
                  md: 4,
                },
                validation: {
                  required: true,
                },
                params: {
                  availableValues: getAvailableTemplateValues,
                },
              },
              {
                name: "fields",
                label: I18n.get.form.labels.fields,
                type: "checkboxes",
                grid: {
                  xs: 12,
                },
                params: {
                  availableValues: I18n.get.card.fields,
                  row: true
                },
              },
              {
                name: "settings",
                label: I18n.get.misc.settings,
                type: "checkboxes",
                grid: {
                  xs: 12,
                  md: 6,
                },
                params: {
                  availableValues: I18n.get.card.settings,
                },
              },
              {
                name: "images",
                label: I18n.get.misc.image,
                type: "file_field",
                grid: {
                  xs: 12,
                  md: 6,
                },
                params: {
                  filetypes: ["image"],
                  multiple: false,
                },
              },

              {
                name: "body",
                label: I18n.get.form.labels.body,
                type: "editor",
                required: false,
                grid: {
                  xs: 12,
                },
              },
            ],
          },
        ]}
        labels={{
          loading: I18n.get.form.labels.loadingContent,
          create: I18n.get.card.labels.createCard,
          created: I18n.get.card.messages.cardSaved,
          updated: I18n.get.card.messages.cardSaved,
          deleted: I18n.get.card.messages.cardDeleted,
          fieldRequired: I18n.get.form.errors.required,
        }}
        operations={{
          category: "card",
          get: GET_CARD,
          create: CREATE_CARD,
          update: UPDATE_CARD,
        }}
        // paths={{
        //   back: "/content/cards",
        // }}
        initialState={getInitialState()}
        pageTitleField="title"
        classes={{
          paper: "vo-global__content-with-toolbar",
          toolbar: "vo-global__content-toolbar",
        }}
        onComplete={handleRedirect}
        onCancel={handleRedirect}
      />
    </Layout>
  );
}
